<template>
  <div class="ad-set-sort-arrows">
    <i class="up-arrow fa fa-angle-up fa-fw"
       aria-hidden="true"
       :class="(sortDirection === 'desc' && sortBy === sortKey) ? 'invisible' : ''">
    </i>
    <i class="down-arrow fa fa-angle-down fa-fw"
       aria-hidden="true"
       :class="(sortDirection === 'asc' && sortBy === sortKey) ? 'invisible' : ''">
    </i>
  </div>
</template>

<script>
  export default {
    name: 'ad-set-sort-arrows',

    props: {
      sortKey: {
        type: String,
        required: true
      },
      sortBy: String,
      sortDirection: String
    }
  }
</script>

<style scoped>
  .ad-set-sort-arrows {
    display: flex;
    flex-direction: column;
  }

  .fa {
    color: rgba(32, 32, 32, .5);
    font-size: 13px;
    line-height: .6;
  }

  .invisible {
    visibility: hidden;
  }
</style>
